import RootState from 'typings/RootState'
import { Event } from '../../types/event'
import { DataList } from './types'

export const selectEvent = (state: RootState): Event =>
  state.adminReportDaily.Event

export const selectReportList = (state: RootState): DataList =>
  state.adminReportDaily.DataList

export const selectFilter = (state: RootState) => state.adminReportDaily.Filter

export const selectInitFilter = (state: RootState) =>
  state.adminReportDaily.ClearFilter

export const selectSorting = (state: RootState) =>
  state.adminReportDaily.sorting
